import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
export function StickyTopBar() {
  const [isVisible, setIsVisible] = useState(true);
  const [dateText, setDateText] = useState('');
  useEffect(() => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const month = tomorrow.toLocaleString('en-US', {
      month: 'long'
    });
    const day = tomorrow.getDate();
    setDateText(`Tomorrow, ${month} ${day}`);
  }, []);
  if (!isVisible) return null;
  return <div className="sticky top-0 left-0 w-full z-[9999] bg-[#FF0000] text-white font-sans flex items-center justify-center px-8 py-2 min-h-[50px] md:h-[50px] shadow-md" data-id="element-249">
      <div className="text-center text-xs md:text-sm font-bold leading-tight max-w-3xl" data-id="element-250">
        <span className="block md:inline" data-id="element-251">
          🔥 Launch Price: $6.37. Price increases to $305 on:{' '}
        </span>
        <span className="block md:inline md:ml-1" data-id="element-252">{dateText}</span>
      </div>

      <button onClick={() => setIsVisible(false)} className="absolute right-2 md:right-4 p-1 hover:bg-white/20 rounded-full transition-colors" aria-label="Close banner" data-id="element-253">
        <X className="w-4 h-4 md:w-5 md:h-5" data-id="element-254" />
      </button>
    </div>;
}